
import axios from 'axios';
import { handleResponse, handleError } from './reponse';
import { CPO_API } from '../config';

const PROJECT_URL = `${CPO_API}/project`;

const getAllProjects = (name = null, causes = [], page = 1, limit = 10) => {
  const keyword = name ?? "";
  const encodedCauses = encodeURIComponent(causes.join(','));
  const isactive =  "&isactive=true";

  return axios
    .get(`${PROJECT_URL}?keyword=${keyword}&causes=${encodedCauses}&page=${page}&limit=${limit}${isactive}`)
    .then(handleResponse)
    .catch(handleError);
};

const getAllProjectsSnippets = () =>
  axios.get(`${PROJECT_URL}/feature`).then(filterProjectSnippets).catch(handleError);

const getProjectDetails = (projectId) =>
  axios
    .get(`${PROJECT_URL}/info?_id=${projectId}`)
    .then(handleResponse)
    .catch(handleError);

const getProjectsByCharity = (charityName) =>
  axios
    .get(`${PROJECT_URL}?charityName=${charityName}`)
    .then(handleResponse)
    .catch(handleError);

const getProjectsByCharityId = (charityId) =>
  axios
    .get(`${PROJECT_URL}/charity/?charityId=${charityId}`)
    .then(handleResponse)
    .catch(handleError);

const getProjectsByCause = (cause) =>
  axios
    .get(PROJECT_URL)
    .then((res) => {
      const causeName = cause === 'All' ? null : cause;
      return filterProjectByCause(causeName, res);
    })
    .catch(handleError);

const filterProjectSnippets = (response) => {
  const data = handleResponse(response);
  // Return raw data from /project/feature endpoint without filtering
  return data ? data.data : [];
};

const filterProjectById = (projectId, response) => {
  const data = handleResponse(response);
  let project = null;
  if (data && data.filter((p) => p.id === projectId && p.isActive)) {
    project = data.filter((p) => p.id === projectId && p.isActive)[0];
  }
  return project;
};

const filterProjectByCause = (causes, response) => {
  const data = handleResponse(response).data.records;
  const filteredData = [];
  let causesList = null;

  if (typeof causes === 'string') {
    causesList = causes.split(',');
  } else if (typeof causes === 'object') {
    causesList = causes;
  }

  if (causesList) {
    causesList.forEach((cause) => {
      data.forEach((project) => {
        if (project.isActive && project.causes.includes(cause)) {
          if (!filteredData.find((e) => e._id === project._id)) {
            filteredData.push(project);
          }
        }
      });
    });
    return filteredData;
  }

  return data;
};

export const ProjectAPI = {
  getAllProjects,
  getAllProjectsSnippets,
  getProjectDetails,
  getProjectsByCause,
  getProjectsByCharity,
  getProjectsByCharityId,
};
